import { create } from 'zustand';

/**
 * F5.7 — Annotations UI state.
 *
 * Two pieces only:
 *   - placing: true while the toolbar is in "drop a note" mode (next
 *     map click captures lat/lon and opens the text editor).
 *   - pendingPlacement: lat/lon captured from the click, awaiting the
 *     user to type and submit / cancel.
 *
 * The list of saved annotations lives in TanStack Query (['annotations']).
 */

interface AnnotationsState {
  placing: boolean;
  startPlacing: () => void;
  cancelPlacing: () => void;
  pendingPlacement: null | { lat: number; lon: number };
  capturePlacement: (lat: number, lon: number) => void;
  clearPendingPlacement: () => void;
}

export const useAnnotationsStore = create<AnnotationsState>((set) => ({
  placing: false,
  startPlacing: () => set({ placing: true, pendingPlacement: null }),
  cancelPlacing: () => set({ placing: false, pendingPlacement: null }),
  pendingPlacement: null,
  capturePlacement: (lat, lon) => set({ pendingPlacement: { lat, lon }, placing: false }),
  clearPendingPlacement: () => set({ pendingPlacement: null }),
}));
